import { Link } from 'react-router-dom'

import { LOGIN_PATH } from '../lib/nav'
import LoginForm from './LoginForm'

export default function AdminLogin() {
  return (
    // โทนกรมท่า + คำว่า "ผู้ดูแล" ตัวโต ๆ ให้ต่างจากหน้าพนักงานชัดเจน
    // สองหน้านี้หน้าตาเหมือนกันแล้วคนจะกรอกผิดทางแล้วโดน 429 ทั้งที่รหัสถูก
    <div className="login login--admin">
      <section className="login-card">
        <img className="brand-logo brand-logo--lg" src="/simat-logo.png" alt="SIMAT Technologies" />
        <p className="login-eyebrow">ระบบหลังบ้าน</p>
        <h1>เข้าสู่ระบบผู้ดูแล</h1>
        <p className="login-lead">สำหรับเจ้าหน้าที่ฝ่ายบุคคลและผู้ดูแลระบบ</p>

        <LoginForm kind="admin" usernameLabel="ชื่อผู้ใช้" usernamePlaceholder="เช่น hr.somchai" />

        <p className="login-alt">
          เป็นพนักงานทั่วไป? <Link to={LOGIN_PATH.user}>เข้าสู่ระบบพนักงาน</Link>
        </p>

        <p className="meta">
          บัญชีผู้ดูแลออกให้โดยผู้ดูแลระบบ ไม่ใช่บัญชีเดียวกับที่พนักงานใช้เข้าระบบ
        </p>
      </section>
    </div>
  )
}
